var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"item-key":"covgId","loading":_vm.dataTableLoading,"loading-text":"Loading... Please wait","hide-default-footer":"","disable-sort":""},scopedSlots:_vm._u([{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('pt-chip',{attrs:{"color":_vm.getColor(item.status)}},[_vm._v(" "+_vm._s(_vm.getStatusText(item))+" ")])]}},{key:"item.assignedDate",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(_vm._f("formatDate")(value,"LL"))+" ")]}},{key:"item.completionDate",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(_vm._f("formatDate")(value,"LL"))+" ")]}},{key:"item.assignees",fn:function(ref){
var value = ref.value;
return [_c('text-and-hovertext',{staticClass:"assignees",attrs:{"text":value.join(', ')}})]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [(
        item.itemType === 'VendorReviewWorkflowItemBehavior' &&
          item.stepAction
      )?_c('v-btn',{attrs:{"depressed":"","color":"primary","href":_vm.vendorReviewPath(item.id)}},[_vm._v(" "+_vm._s(item.stepAction.label)+" ")]):(item.stepAction)?_c('v-btn',{attrs:{"depressed":"","color":"primary","to":{
        name: 'workflowStep',
        params: {
          covgId: _vm.covgId,
          itemId: item.id
        }
      }}},[_vm._v(" "+_vm._s(item.stepAction.label)+" ")]):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }